import { render, staticRenderFns } from "./categoryCard.vue?vue&type=template&id=6d0c76cd&scoped=true&"
import script from "./categoryCard.vue?vue&type=script&lang=js&"
export * from "./categoryCard.vue?vue&type=script&lang=js&"
import style0 from "./categoryCard.vue?vue&type=style&index=0&id=6d0c76cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0c76cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
